import { CUSTOMER } from "../api/constApi";
import { apiInstance } from "./axiosApi";

export const Customer = (payload) => {
  return apiInstance.post(CUSTOMER, payload);
};
